module.exports = __webpack_public_path__ + "static/media/sinister_type_flood.8c3cc498.svg";